import React from "react";
import { SpaceShape } from "venuescanner-js/react/shapes";

const WouldBookAgain = ({ space }) => {
  const percentage = parseInt((space.rating / 5) * 100);
  if (percentage < 60) return null;

  return (
    <div className="space-tile__review--would-book-again">
      <span>{percentage}% would book it again</span>
    </div>
  );
};

WouldBookAgain.propTypes = {
  space: SpaceShape.isRequired,
};

export default WouldBookAgain;
